// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AdminWorkflowsCollaboratorsRemoveResponse = SlackAPIResponse & {
  error?: string;
  errors?: Error[];
  needed?: string;
  ok: boolean;
  provided?: string;
};

export interface Error {
  message?: string;
  user?: string;
  workflow?: string;
}
